import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { Control } from 'src/app/control/model/control.model';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogActions } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { selectOrphanControls } from '../../control/store/control.selector';
import { linkControlToBuilding } from '../../control/store/control.action';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ValidateButtonComponent } from '../../shared/buttons/validate-button.component';
import { SecondaryButtonComponent } from '../../shared/buttons/secondary-button.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { AsyncPipe, DatePipe } from '@angular/common';

@Component({
  selector: 'sibat-link-control-to-building',
  template: `
    <div mat-dialog-title class="title-container">
      <h2>{{ 'building.linkControlToBuilding' | transloco }}</h2>
    </div>

    <div class="orphan-controls-container">
      <mat-radio-group class="orphan-controls-wrapper" [(ngModel)]="selectedControl">
        @for (control of orphanControls$ | async; track control) {
        <mat-radio-button class="orphan-control-item" [value]="control">
          {{ control.designation ? control.designation : control.id }}
          ({{ control.date | date }})&nbsp;
        </mat-radio-button>
        }
      </mat-radio-group>
    </div>

    <mat-dialog-actions align="end">
      <sibat-validate-button
        class="mat-button-base"
        (clicked)="linkControl()"
        [label]="'common.validate' | transloco"
        [disabled]="!!!selectedControl"
      >
      </sibat-validate-button>
      <sibat-secondary-button class="mat-button-base" (clicked)="close()" [label]="'layout.closeDialog' | transloco">
      </sibat-secondary-button>
    </mat-dialog-actions>
  `,
  styleUrls: ['./link-control-to-building.scss'],
  imports: [
    MatDialogTitle,
    MatRadioGroup,
    ReactiveFormsModule,
    FormsModule,
    MatRadioButton,
    MatDialogActions,
    ValidateButtonComponent,
    SecondaryButtonComponent,
    TranslocoPipe,
    AsyncPipe,
    DatePipe,
  ],
})
export class LinkControlToBuildingComponent {
  @Output() linkControlToBuilding = new EventEmitter<number>();

  orphanControls$ = this.store.select(selectOrphanControls);
  selectedControl: Control;

  constructor(
    private dialogRef: MatDialogRef<LinkControlToBuildingComponent>,
    private store: Store,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) private data: { buildingId: number }
  ) {}

  close() {
    this.dialogRef.close();
  }

  linkControl() {
    this.store.dispatch(linkControlToBuilding({ controlId: this.selectedControl.id, buildingId: this.data.buildingId }));
    this.linkControlToBuilding.emit(this.selectedControl.id);
    this.close();
  }
}
